import React from 'react';
import './Partservice.css';
import partserImage from '../imgs/partser.webp'; // adjust the path as needed

const Partservice = () => {
  return (
    <div className="parts-service-container">
      <div className="text-section" data-aos="flip-left">
        <h2>Parts & Service</h2>
        <p className="highlighted">
          Screw, Valves, Nozzle, Gasket, Auxiliary Machinery
        </p>
        <p>
          As a direct manufacturer, we guarantee competitive prices and product quality.
          With our global service network, we ensure timely and professional support anywhere you are.
          Choose us for factory-direct pricing and world-class service.
        </p>
        <button className="support-btn">Get Global Support</button>
      </div>

      <div className="image-section" data-aos="flip-right">
        <img src={partserImage} alt="Parts and Service" />
      </div>
    </div>
  );
};

export default Partservice;
